import React from 'react';
import styled from 'styled-components';
import { helpDeskButtonDiameter } from '../constants/helpDesk';
import { Toolbar } from './Toolbar';

const StyledToolbar = styled(Toolbar)`
  flex-shrink: 0;
  padding-right: ${helpDeskButtonDiameter};
`;

type FooterProps = Pick<
  React.ComponentProps<typeof Toolbar>,
  'centerActions' | 'leftActions' | 'rightActions' | 'size' | 'variant'
>;

export function Footer(props: FooterProps) {
  return <StyledToolbar component="footer" position="relative" {...props} />;
}
